var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"term-privacy-page w-100"},[_c('SectionDonate'),_c('SectionPhone',{staticClass:"mt-5 pb-3 pt-3 pb-md-5 pb-xxl-5 bg-white"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }